"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactSharedUiNext = require("@eon-funke/react-shared-ui-next");
var _InputValidationHelper = require("../../../../../utils/InputValidationHelper");
var _meterReadDropdownHelper = require("../../utils/meterReadDropdownHelper");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var MeterReadingDropdown = function MeterReadingDropdown(props) {
  var _register$possibleRea;
  var readingNotes = props.readingNotes,
    formikProps = props.formikProps,
    formikIdentifier = props.formikIdentifier,
    name = props.name,
    register = props.register,
    dropdownLabel = props.dropdownLabel,
    firstDropdownOptionText = props.firstDropdownOptionText;
  var setFieldValue = formikProps.setFieldValue,
    touched = formikProps.touched;
  var reasons = (_register$possibleRea = register.possibleReadingNotes) !== null && _register$possibleRea !== void 0 ? _register$possibleRea : [];
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var dropOptions = (0, _meterReadDropdownHelper.getDropOptions)(reasons, readingNotes, firstDropdownOptionText);
  var onChange = function onChange(value) {
    setFieldValue("".concat(formikIdentifier, ".readingNoteNumber"), value);
    setFieldValue("".concat(formikIdentifier, ".errorCode"), undefined);
    setIsOpen(false);
  };
  return /*#__PURE__*/_react.default.createElement("div", null, dropOptions.length > 1 && /*#__PURE__*/_react.default.createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Dropdown, {
    qaId: "dropdown",
    name: name,
    isOpen: isOpen,
    onChange: onChange,
    onClick: function onClick() {
      return setIsOpen(!isOpen);
    },
    label: dropdownLabel,
    inputState: (0, _InputValidationHelper.setInputState)(!register.readingNoteNumber, touched[formikIdentifier]),
    options: dropOptions,
    required: true,
    value: register.readingNoteNumber
  })));
};
var _default = exports.default = MeterReadingDropdown;